import { useEffect, useState } from "react";
import type { WorkflowRun } from "../hooks/useWorkflows";

const STATUS_COLORS: Record<string, string> = {
  completed: "text-green-600",
  running: "text-blue-600",
  pending: "text-yellow-600",
  failed: "text-red-600",
};

export function WorkflowRunHistory({
  workflowId,
  getRuns,
}: {
  workflowId: string;
  getRuns: (id: string) => Promise<WorkflowRun[]>;
}) {
  const [runs, setRuns] = useState<WorkflowRun[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getRuns(workflowId)
      .then(setRuns)
      .finally(() => setLoading(false));
  }, [workflowId, getRuns]);

  if (loading) {
    return <div className="py-4 text-sm text-gray-400">Loading runs...</div>;
  }

  if (runs.length === 0) {
    return <div className="py-4 text-sm text-gray-400">No runs yet</div>;
  }

  return (
    <div className="mt-2 space-y-2">
      {runs.map((run) => (
        <div
          key={run.id}
          className="flex items-center justify-between rounded border px-3 py-2 text-sm"
        >
          <div className="flex items-center gap-3">
            <span className={STATUS_COLORS[run.status] || "text-gray-500"}>
              {run.status}
            </span>
            <span className="text-gray-400">
              {new Date(run.triggeredAt).toLocaleString()}
            </span>
          </div>
          <div className="flex items-center gap-3 text-xs text-gray-400">
            {run.durationMs != null && (
              <span>{(run.durationMs / 1000).toFixed(1)}s</span>
            )}
            {run.totalCostUsd && <span>${run.totalCostUsd}</span>}
            {run.error && (
              <span className="text-red-500" title={run.error}>
                error
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
